import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authService } from '../api/axios';
import { clarityEvent } from '../utils/clarity';
import './AuthForm.css';

const Register = () => {
    const [email,    setEmail]    = useState('');
    const [password, setPassword] = useState('');
    const [error,    setError]    = useState('');
    const [success,  setSuccess]  = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        if (password.length < 8) {
            setError('Password must be at least 8 characters long.');
            return;
        }

        try {
            await authService.post('/auth/register', {
                username: email,
                email,
                password,
            });
            clarityEvent('register_success');
            setSuccess('Registration successful! Please check your email to verify your account.');
            setTimeout(() => navigate('/login'), 3000);
        } catch (err) {
            const errorMessage = err.response?.data?.message || err.response?.data || 'Registration failed. Please try again.';
            setError(errorMessage);
        }
    };

    return (
        <div className="auth-container">
            {/* ── Brand panel ── */}
            <div className="auth-welcome-panel">
                <div className="welcome-content">
                    <div className="welcome-content__brand">
                        <span className="welcome-content__brand-name">eYantra</span>
                        <span className="welcome-content__brand-dot" />
                        <span className="welcome-content__brand-name" style={{ fontWeight: 400, opacity: 0.75 }}>Commerce</span>
                    </div>
                    <h1>Start Ordering Smarter.</h1>
                    <p>Join hundreds of businesses that trust eYantra for their corporate merchandise and branded product needs.</p>
                    <div className="welcome-content__trust">
                        <div className="welcome-trust-item">
                            <div className="welcome-trust-item__icon">🏢</div>
                            <span>Built for Corporates &amp; Institutions</span>
                        </div>
                        <div className="welcome-trust-item">
                            <div className="welcome-trust-item__icon">🤝</div>
                            <span>Dedicated Account Manager for Every Client</span>
                        </div>
                        <div className="welcome-trust-item">
                            <div className="welcome-trust-item__icon">📋</div>
                            <span>Official Quotes &amp; GST Invoices Provided</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* ── Form panel ── */}
            <div className="auth-form-panel">
                <div className="auth-form-container">
                    <Link to="/" className="back-home-link">← Back to Home</Link>

                    <h2>Sign Up</h2>
                    <p className="form-subtitle">Create an account to get started.</p>

                    <form onSubmit={handleSubmit}>
                        <div className="input-group">
                            <input
                                type="email"
                                className="auth-input"
                                placeholder="Email Address"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </div>
                        <div className="input-group">
                            <input
                                type="password"
                                className="auth-input"
                                placeholder="Password (min. 8 characters)"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                        </div>

                        {error   && <p className="error-message">{error}</p>}
                        {success && <p className="success-message">{success}</p>}

                        <button type="submit" className="auth-button-primary">
                            Create Account
                        </button>
                    </form>

                    <p className="auth-switch-prompt">
                        Already have an account? <Link to="/login" className="auth-link">Log In</Link>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Register;
